import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText, Save } from "lucide-react";
import { api, fileUrl, errMsg, fmtDate } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const AdminCatalog = () => {
  const [cat, setCat] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [pdf, setPdf] = useState(null);
  const [cover, setCover] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/catalog").then((r) => { setCat(r.data); setTitle(r.data.title); setDescription(r.data.description); });
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("title", title);
    fd.append("description", description);
    if (pdf) fd.append("pdf", pdf);
    if (cover) fd.append("cover", cover);
    setBusy(true);
    try {
      await api.post("/admin/catalog", fd);
      toast.success(pdf ? "Catálogo actualizado" : "Datos guardados");
      setPdf(null); setCover(null); e.target.reset();
      load();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="grid gap-6 lg:grid-cols-12" data-testid="admin-catalog">
      <form onSubmit={submit} className="card-fv p-6 sm:p-8 space-y-5 lg:col-span-8">
        <div className="space-y-2"><Label>Título</Label><Input value={title} onChange={(e) => setTitle(e.target.value)} required data-testid="admin-catalog-title-input" /></div>
        <div className="space-y-2"><Label>Descripción</Label><Textarea rows={5} value={description} onChange={(e) => setDescription(e.target.value)} data-testid="admin-catalog-description-input" /></div>
        <div className="grid gap-5 sm:grid-cols-2">
          <div className="space-y-2"><Label>Nuevo catálogo (PDF)</Label><Input type="file" accept="application/pdf" onChange={(e) => setPdf(e.target.files[0])} data-testid="admin-catalog-pdf-input" /></div>
          <div className="space-y-2"><Label>Imagen de portada (opcional)</Label><Input type="file" accept="image/*" onChange={(e) => setCover(e.target.files[0])} data-testid="admin-catalog-cover-input" /></div>
        </div>
        <button disabled={busy} className="btn-fv btn-red disabled:opacity-60" data-testid="admin-catalog-save-button"><Save size={16} />{busy ? "Guardando…" : "Guardar"}</button>
      </form>
      <div className="card-fv p-6 lg:col-span-4 space-y-4" data-testid="admin-catalog-current">
        <p className="eyebrow">Catálogo vigente</p>
        {cat?.cover_url && <img src={fileUrl(cat.cover_url)} alt="" className="aspect-[3/4] w-full object-cover" />}
        {cat?.pdf_url ? (
          <>
            <a href={fileUrl(cat.pdf_url)} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-[#8B2B22] font-semibold" data-testid="admin-catalog-current-pdf"><FileText size={18} />Ver PDF actual</a>
            <p className="text-sm text-[#5C635E]">Actualizado el {fmtDate(cat.updated_at)}</p>
          </>
        ) : <p className="text-sm text-[#5C635E]" data-testid="admin-catalog-no-pdf">Todavía no se subió ningún PDF.</p>}
      </div>
    </div>
  );
};
